<template>
  <div >
    <v-app-bar fixed app color="#262A34" dark >
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title v-text="title" /> -->
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-app-bar-nav-icon @click.stop="mini = !mini"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
       <v-menu bottom>
        <template v-slot:activator="{ on, attrs }">

          <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-account-switch</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="(item, i) in userTypeGroupSelect"
              :key="i"
              @change="changeTypeGroup(item)"
            >
              <!-- <v-list-item-icon>
              <v-icon>mdi-account-convert </v-icon>
            </v-list-item-icon> -->
              <v-list-item-content>
                <v-list-item-title v-text="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini"
      permanent bottom fixed app color="#262A34" dark v-bind:width="325">
      <v-list>
        <v-list-item to="/Core/Home" class="px-2">
          <v-list-item-avatar>
            <v-img :src="imageUrl"></v-img>
          </v-list-item-avatar>
          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title>
                {{ empFull_NameTH }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ empEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list>
          <v-list-group
            v-for="(topic, i) in ListHeaderMenu"
            :key="i"
            :value="true"
            class="menu-head"
            color="#871B12"
            prepend-icon="mdi-folder-open"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ topic.menuName }}</v-list-item-title>
            </template>
            <!-- ข้อมูลหลัก -->
            <v-list-group
              v-for="(header, i) in topic.header"
              :key="i"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ header.menuName }}</v-list-item-title>
                  <!-- <v-list-item-title><v-icon>{{ icons.mdiFolderOutline  }}</v-icon>{{ header.menuName }}</v-list-item-title> -->
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(item, i) in header.sub"
                :key="i"
                :to="item.menuPath"
                color="#871B12"
                class="text-white"
              >
              <v-list-item-icon v-if="item.icon">
          <!-- <v-icon>{{ item.icon  }}</v-icon> -->
          <v-icon>{{ item.icon  }}</v-icon>
        </v-list-item-icon>
                <v-list-item-content>
                   <!-- <v-icon>{{ icons.mdiFileTable  }}</v-icon> -->
                  <v-list-item-title v-text="item.menuName"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
        </v-list>
      </v-list>
      <template v-slot:append>
        <v-divider class="ma-0"></v-divider>
        <div class="px-2 nav-button" >
          <v-btn block
            text
            tile
            class="nav-button"
            @click.prevent="logout()">
            <v-icon color="white">mdi-logout</v-icon>&nbsp;&nbsp;ออกจากระบบ
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios'
import {
  mdiFolderOutline,
  mdiFileTable
} from '@mdi/js'

export default {
  data () {
    return {
      title: 'HRM - Vgroup Honda',
      drawer: true,
      mini: true,
      session: this.$session.getAll(),
      ListMenu: [],
      ListHeaderMenu: [],
      ListTopicMenu: [],
      roll: '',
      imageUrl: '',
      empFull_NameTH: '',
      empEmail: '',
      userTypeGroup: '',
      selectedItem: '',
      userTypeGroupSelect: [],
      icon: '',
      icons: {
        mdiFolderOutline,
        mdiFileTable
      }
    }
  },
  computed: {},
  async mounted () {
    await this.setUpprofile()
    await this.getMenu()
  },
  methods: {
    async setUpprofile () {
      var data = JSON.parse(localStorage.getItem('data'))
      this.empFull_NameTH = data.empFull_NameTH
      this.empEmail = data.empEmail
      this.userTypeGroup = data.userTypeGroup
      if (data.empImageUrl) {
        this.imageUrl = this.DNS_IP + '/' + data.empImageUrl
      } else {
        this.imageUrl = require('@/assets/avatar.png')
      }
      this.setSelectUserTypeGroup(data.userSubTypeGroup)
    },
    async setSelectUserTypeGroup (typegroup) {
      console.log(typegroup)
      this.userTypeGroupSelect = []
      this.userTypeGroupSelect = JSON.parse(typegroup)
      console.log(this.userTypeGroupSelect.length)
    },
    async changeTypeGroup (dt) {
      console.log('changeTypeGroup', this.selectedItem)
      this.ListMenu = []
      this.ListHeaderMenu = []
      this.ListTopicMenu = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_menu/get?RECORD_STATUS=N&userTypeGroup=" + dt
        )
        .then(async (response) => {
          // console.log('Menu', response.data)
          localStorage.roll = dt
          this.userTypeGroup = dt
          localStorage.setItem('menu', JSON.stringify(response.data))
          this.getMenuSelect(response.data)
          // location.reload()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },

    async getMenuSelect (menu) {
      // Set Menu
      // var menu = JSON.parse(localStorage.getItem('menu'))
      var ListMenu = []
      var ListHeaderMenu = []
      var ListTopicMenu = []
      menu.forEach((element) => {
        if (element.menuType === 'Topic') {
          ListTopicMenu.push(element)
        } else if (element.menuType === 'Header') {
          ListHeaderMenu.push(element)
        } else if (element.menuType === 'Sub') {
          ListMenu.push(element)
        }
      })

      ListTopicMenu.forEach((objTopic) => {
        var h = []
        ListHeaderMenu.forEach((objHeader) => {
          if (objTopic.menuCode === objHeader.menuRefCodeHeader) {
            // console.log('objTopic.menuName', objTopic.menuName)
            // console.log('objHeader.menuRefCodeHeader', objHeader.menuRefCodeHeader)
            // console.log('objHeader.menuCode', objHeader.menuCode)
            h.push(objHeader)
            objTopic.header = h
          }
        })
        this.ListHeaderMenu.push(objTopic)
      })

      this.ListHeaderMenu.forEach((el_) => {
        if (el_.header !== null) {
          var Subs = []
          var x = el_.header
          x.forEach((el2) => {
            Subs.push(el2)
          })
          Subs.forEach((element) => {
            var s = []
            ListMenu.forEach((element2) => {
              if (element2.menuRefCodeHeader === element.menuCode) {
                // console.log('element.menuName', element.menuName)
                // console.log('element2.menuRefCodeHeader', element2.menuRefCodeHeader)
                // console.log('objHeader.menuCode', element2.menuCode)
                // console.log('objHeader.menuCode', element.menuCode)
                // console.log('----------------')
                element2.header = element
                s.push(element2)
              }
            })
            var y = []
            s.forEach((elX) => {
              if (element.menuCode === elX.menuRefCodeHeader) {
                // console.log('elX.menuCode', elX.menuCode)
                // console.log('element.menuCode', element.menuCode)
                // console.log('----------------')
                y.push(elX)
                element.sub = y
              }
            })
            this.ListMenu.push(element)
          })
        }
      })

      var count = 0
      menu.forEach((element) => {
        if (element.menuPath === this.$route.path) {
          count += count + 1
        }
      })
      // console.log('count', count)
      if (count < 1 && this.$route.path !== '/Core/Home') {
        this.$router.push('/Core/Login')
      }
    },
    async getMenu () {
      // Set Menu
      var menu = JSON.parse(localStorage.getItem('menu'))
      if (menu) {
        var ListMenu = []
        var ListHeaderMenu = []
        var ListTopicMenu = []
        menu.forEach((element) => {
          if (element.menuType === 'Topic') {
            ListTopicMenu.push(element)
          } else if (element.menuType === 'Header') {
            ListHeaderMenu.push(element)
          } else if (element.menuType === 'Sub') {
            ListMenu.push(element)
          }
        })

        ListTopicMenu.forEach((objTopic) => {
          var h = []
          ListHeaderMenu.forEach((objHeader) => {
            // console.log('objTopic.menuCode ', objTopic.menuCode)
            // console.log('objHeader.menuRefCodeHeader ', objHeader.menuRefCodeHeader)
            // if (objHeader.menuRefCodeHeader != null) {
            if (objTopic.menuCode === objHeader.menuRefCodeHeader) {
              // console.log('H', objTopic.menuName)
              // console.log('objTopic.menuName', objTopic.menuName)
              // console.log('objHeader.menuName', objHeader.menuName)
              // console.log('objHeader.menuRefCodeHeader', objHeader.menuRefCodeHeader)
              // console.log('objTopic.menuCode', objTopic.menuCode)
              // console.log('objHeader.menuCode', objHeader.menuCode)
              // console.log('----------------')
              // console.log('objTopic ', objHeader)
              h.push(objHeader)
              objTopic.header = h
            }
            // }
          })
          // console.log('objTopic ', objTopic)
          this.ListHeaderMenu.push(objTopic)
        })
        // console.log('this.ListHeaderMenu ', this.ListHeaderMenu)
        this.ListHeaderMenu.forEach((el_) => {
          // console.log('ListHeaderMenu ', el_)
          if (el_.header !== null) {
            // console.log('el_.header ', el_.header)
            var Subs = []
            var x = el_.header
            x.forEach((el2) => {
              Subs.push(el2)
            })
            Subs.forEach((element) => {
              var s = []
              // console.log('ListMenu ', ListMenu)
              ListMenu.forEach((element2) => {
                if (element2.menuRefCodeHeader === element.menuCode) {
                  // console.log('H element2 name ', element2.menuName)
                  // console.log('H element name ', element.menuName)
                  // console.log('element2.menuRefCodeHeader', element2.menuRefCodeHeader)
                  // console.log('element.menuName', element.menuName)
                  // console.log('element.menuCode', element.menuCode)
                  // console.log('element2.menuCode', element2.menuCode)
                  // console.log('----------------')
                  element2.header = element
                  s.push(element2)
                }
              })
              var y = []
              s.forEach((elX) => {
                if (element.menuCode === elX.menuRefCodeHeader) {
                  // console.log('elX.menuRefCodeHeader', elX.menuRefCodeHeader)
                  // console.log('element.menuName', element.menuName)
                  // console.log('element.menuCode', element.menuCode)
                  // console.log('elX.menuCode', elX.menuCode)
                  // console.log('----------------')
                  y.push(elX)
                  element.sub = y
                }
              })
              this.ListMenu.push(element)
            })
          }
        })

        var count = 0
        menu.forEach((element) => {
          if (element.menuPath === this.$route.path) {
            count += count + 1
          }
        })
        // console.log('count', count)
        if (count < 1 && this.$route.path !== '/Core/Home') {
          this.$router.push('/Core/Login')
        }
      }
    },
    async ClearlocalStorage () {
      localStorage.clear()
    },
    logout () {
      this.ClearlocalStorage()
      this.$router.push('/Core/Login')
    }
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue